import { ENV } from '@shared/config';

import { createService } from './create-service';

export const productService = createService(ENV.VITE_PRODUCT_SERVICE);
